import { SearchPageType } from '@zoopla/listing-search-context';

export const getPriceFrequencyParam = (
    searchType: SearchPageType,
    priceFrequency: string
) => {
    const isRent = searchType === 'to-rent';
    if (!isRent) {
        return '';
    }

    if (priceFrequency === 'per_week') {
        return 'per_week';
    }

    return 'per_month';
};
